declare namespace $ {

	type $mol_view__sub_shm_paginator_1 = $mol_type_enforce<
		ReturnType< $shm_paginator['buttons'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_paginator_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_paginator_3 = $mol_type_enforce<
		ReturnType< $shm_paginator['button_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__attr_shm_paginator_4 = $mol_type_enforce<
		({ 
			'aria-current': ReturnType< $shm_paginator['button_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__click_shm_paginator_5 = $mol_type_enforce<
		ReturnType< $shm_paginator['pick'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_paginator_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_paginator extends $mol_view {
		buttons( ): readonly(any)[]
		Numbers( ): $mol_view
		info( ): string
		Info( ): $mol_view
		button_title( id: any): string
		button_current( id: any): any
		pick( id: any, next?: any ): any
		page( next?: number ): number
		total( ): number
		page_size( ): number
		sub( ): readonly(any)[]
		Button( id: any): $mol_button_minor
		Gap( id: any): $mol_view
	}
	
}

//# sourceMappingURL=paginator.view.tree.d.ts.map